import { render, staticRenderFns } from "./SuccessTab.vue?vue&type=template&id=3c24f1ef&"
import script from "./SuccessTab.vue?vue&type=script&lang=js&"
export * from "./SuccessTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports